export enum IUserManagementActionTypes {
	ADD_USER_RESOURCE_RIGHTS = '@@userManagement/ADD_USER_RESOURCE_RIGHTS',
	ADD_USER_RESOURCE_RIGHTS_FAILED = '@@userManagement/ADD_USER_RESOURCE_RIGHTS_FAILED',
	ADD_USER_RESOURCE_RIGHTS_SUCCEED = '@@userManagement/ADD_USER_RESOURCE_RIGHTS_SUCCEED',
	CREATE_ACL_USERS = '@@userManagement/CREATE_ACL_USERS',
	CREATE_ACL_USERS_FAILED = '@@userManagement/CREATE_ACL_USERS_FAILED',
	CREATE_ACL_USERS_SUCCEED = '@@userManagement/CREATE_ACL_USERS_SUCCEED',
	CREATE_MULTIPLE__ACL_USERS_FAILED = '@@userManagement/CREATE_MULTIPLE__ACL_USERS_FAILED',
	CREATE_MULTIPLE__ACL_USERS_SUCCEED = '@@userManagement/CREATE_MULTIPLE__ACL_USERS_SUCCEED',
	CREATE_MULTIPLE_ACL_USERS = '@@userManagement/CREATE_MULTIPLE_ACL_USERS',
	DELETE_USER_RESOURCE = '@@userManagement/DELETE_USER_RESOURCE',
	DELETE_USER_RESOURCE_FAILED = '@@userManagement/DELETE_USER_RESOURCE_FAILED',
	DELETE_USER_RESOURCE_SUCEED = '@@userManagement/DELETE_USER_RESOURCE_SUCEED',
	EMPTY_LIST = '@@userManagement/EMPTY_LIST',
	EMPTY_LIST_RESOURCES = '@@userManagement/EMPTY_LIST_RESOURCES',
	EMPTY_LIST_RIGHTS = '@@userManagement/EMPTY_LIST_RIGHTS',
	EMPTY_LIST_USERNAMES = '@@userManagement/EMPTY_LIST_USERNAMES',
	GET_ACL_PARENTS = '@@userManagement/GET_ACL_PARENTS',
	GET_ACL_PARENTS_FAILED = '@@userManagement/GET_ACL_PARENTS_FAILED',
	GET_ACL_PARENTS_SUCCEED = '@@userManagement/GET_ACL_PARENTS_SUCCEED',
	GET_ACL_RIGHTS = '@@userManagement/GET_ACL_RIGHTS',
	GET_ACL_RIGHTS_FAILED = '@@userManagement/GET_ACL_RIGHTS_FAILED',
	GET_ACL_RIGHTS_SUCCEED = '@@userManagement/GET_ACL_RIGHTS_SUCCEED',
	GET_ACL_USER_BY_ID = '@@userManagement/GET_ACL_USER_BY_ID',
	GET_ACL_USER_BY_ID_FAILED = '@@userManagement/GET_ACL_USER_BY_ID_FAILED',
	GET_ACL_USER_BY_ID_SUCCEED = '@@userManagement/GET_ACL_USER_BY_ID_SUCCEED',
	GET_ACL_USERS = '@@userManagement/GET_ACL_USERS',
	GET_ACL_USERS_FAILED = '@@userManagement/GET_ACL_USERS_FAILED',
	GET_ACL_USERS_SUCCEED = '@@userManagement/GET_ACL_USERS_SUCCEED',
	GET_ALL_ACL_USERNAMES = '@@userManagement/GET_ALL_ACL_USERNAMES',
	GET_ALL_ACL_USERNAMES_FAILED = '@@userManagement/GET_ALL_ACL_USERNAMES_FAILED',
	GET_ALL_ACL_USERS_SUCCEED = '@@userManagement/GET_ALL_ACL_USERS_SUCCEED',
	GET_USER_RIGHTS = '@@userManagement/GET_USER_RIGHTS',
	GET_USER_RIGHTS_FAILED = '@@userManagement/GET_USER_RIGHTS_FAILED',
	GET_USER_RIGHTS_SUCCEED = '@@userManagement/GET_USER_RIGHTS_SUCCEED',
	IMPERSONATE = '@@userManagement/IMPERSONATE',
	IMPERSONATE_FAILED = '@@userManagement/IMPERSONATE_FAILED',
	IMPERSONATE_SUCCEED = '@@userManagement/IMPERSONATE_SUCCEED',
	IS_LOADING = '@@userManagement/IS_LOADING',
	IS_USER_ALREADY_PRESENT = '@@userManagement/IS_USER_ALREADY_PRESENT',
	IS_USER_ALREADY_PRESENT_FAILED = '@@userManagement/IS_USER_ALREADY_PRESENT_FAILED',
	IS_USER_ALREADY_PRESENT_SUCCEED = '@@userManagement/IS_USER_ALREADY_PRESENT_SUCCEED',
	MODIFY_ACL_USER = '@@userManagement/MODIFY_ACL_USER',
	MODIFY_ACL_USER_DATE_DEBUT = '@@userManagement/MODIFY_ACL_USER_DATE_DEBUT',
	MODIFY_ACL_USER_DATE_DEBUT_FAILED = '@@userManagement/MODIFY_ACL_USER_DATE_DEBUT_FAILED',
	MODIFY_ACL_USER_DATE_DEBUT_SUCCEED = '@@userManagement/MODIFY_ACL_USER_DATE_DEBUT_SUCCEED',
	MODIFY_ACL_USER_DATE_EXPIRE = '@@userManagement/MODIFY_ACL_USER_DATE_EXPIRE',
	MODIFY_ACL_USER_DATE_EXPIRE_FAILED = '@@userManagement/MODIFY_ACL_USER_DATE_EXPIRE_FAILED',
	MODIFY_ACL_USER_DATE_EXPIRE_SUCCEED = '@@userManagement/MODIFY_ACL_USER_DATE_EXPIRE_SUCCEED',
	MODIFY_ACL_USER_EMAIL = '@@userManagement/MODIFY_ACL_USER_EMAIL',
	MODIFY_ACL_USER_EMAIL_FAILED = '@@userManagement/MODIFY_ACL_USER_EMAIL_FAILED',
	MODIFY_ACL_USER_EMAIL_SUCCEED = '@@userManagement/MODIFY_ACL_USER_EMAIL_SUCCEED',
	MODIFY_ACL_USER_FAILED = '@@userManagement/MODIFY_ACL_USER_FAILED',
	MODIFY_ACL_USER_FIRSTNAME = '@@userManagement/MODIFY_ACL_USER_FIRSTNAME',
	MODIFY_ACL_USER_FIRSTNAME_FAILED = '@@userManagement/MODIFY_ACL_USER_FIRSTNAME_FAILED',
	MODIFY_ACL_USER_FIRSTNAME_SUCCEED = '@@userManagement/MODIFY_ACL_USER_FIRSTNAME_SUCCEED',
	MODIFY_ACL_USER_IS_ACTIVE = '@@userManagement/MODIFY_ACL_USER_IS_ACTIVE',
	MODIFY_ACL_USER_IS_ACTIVE_FAILED = '@@userManagement/MODIFY_ACL_USER_IS_ACTIVE_FAILED',
	MODIFY_ACL_USER_IS_ACTIVE_SUCCEED = '@@userManagement/MODIFY_ACL_USER_IS_ACTIVE_SUCCEED',
	MODIFY_ACL_USER_LANGUAGE = '@@userManagement/MODIFY_ACL_USER_LANGUAGE',
	MODIFY_ACL_USER_LANGUAGE_FAILED = '@@userManagement/MODIFY_ACL_USER_LANGUAGE_FAILED',
	MODIFY_ACL_USER_LANGUAGE_SUCCEED = '@@userManagement/MODIFY_ACL_USER_LANGUAGE_SUCCEED',
	MODIFY_ACL_USER_LOCALISATION = '@@userManagement/MODIFY_ACL_USER_LOCALISATION',
	MODIFY_ACL_USER_LOCALISATION_FAILED = '@@userManagement/MODIFY_ACL_USER_LOCALISATION_FAILED',
	MODIFY_ACL_USER_LOCALISATION_SUCCEED = '@@userManagement/MODIFY_ACL_USER_LOCALISATION_SUCCEED',
	MODIFY_ACL_USER_NAME = '@@userManagement/MODIFY_ACL_USER_NAME',
	MODIFY_ACL_USER_NAME_FAILED = '@@userManagement/MODIFY_ACL_USER_NAME_FAILED',
	MODIFY_ACL_USER_NAME_SUCCEED = '@@userManagement/MODIFY_ACL_USER_NAME_SUCCEED',
	MODIFY_ACL_USER_PARENT = '@@userManagement/MODIFY_ACL_USER_PARENT',
	MODIFY_ACL_USER_PARENT_FAILED = '@@userManagement/MODIFY_ACL_USER_PARENT_FAILED',
	MODIFY_ACL_USER_PARENT_SUCCEED = '@@userManagement/MODIFY_ACL_USER_PARENT_SUCCEED',
	MODIFY_ACL_USER_PHONE = '@@userManagement/MODIFY_ACL_USER_PHONE',
	MODIFY_ACL_USER_PHONE_FAILED = '@@userManagement/MODIFY_ACL_USER_PHONE_FAILED',
	MODIFY_ACL_USER_PHONE_SUCCEED = '@@userManagement/MODIFY_ACL_USER_PHONE_SUCCEED',
	MODIFY_ACL_USER_POSITION = '@@userManagement/MODIFY_ACL_USER_POSITION',
	MODIFY_ACL_USER_POSITION_FAILED = '@@userManagement/MODIFY_ACL_USER_POSITION_FAILED',
	MODIFY_ACL_USER_POSITION_SUCCEED = '@@userManagement/MODIFY_ACL_USER_POSITION_SUCCEED',
	MODIFY_ACL_USER_SUCCEED = '@@userManagement/MODIFY_ACL_USER_SUCCEED',
	MODIFY_ACL_USER_USERNAME = '@@userManagement/MODIFY_ACL_USER_USERNAME',
	MODIFY_ACL_USER_USERNAME_FAILED = '@@userManagement/MODIFY_ACL_USER_USERNAME_FAILED',
	MODIFY_ACL_USER_USERNAME_SUCCEED = '@@userManagement/MODIFY_ACL_USER_USERNAME_SUCCEED',
	SET_LAST_PARAMS = '@@userManagement/SET_LAST_PARAMS',
	SET_LAST_PARAMS_SHORTING = '@@userManagement/SET_LAST_PARAMS_SHORTING',
	UPDATE_ACL_USER_MODIFIED_EMAIL = '@@userManagement/UPDATE_ACL_USER_MODIFIED_EMAIL',
	UPDATE_ACL_USER_MODIFIED_END_DATE = '@@userManagement/UPDATE_ACL_USER_MODIFIED_END_DATE',
	UPDATE_ACL_USER_MODIFIED_FIRSTNAME = '@@userManagement/UPDATE_ACL_USER_MODIFIED_FIRSTNAME',
	UPDATE_ACL_USER_MODIFIED_LANGUAGE = '@@userManagement/UPDATE_ACL_USER_MODIFIED_LANGUAGE',
	UPDATE_ACL_USER_MODIFIED_LOCALISATION = '@@userManagement/UPDATE_ACL_USER_MODIFIED_LOCALISATION',
	UPDATE_ACL_USER_MODIFIED_NAME = '@@userManagement/UPDATE_ACL_USER_MODIFIED_NAME',
	UPDATE_ACL_USER_MODIFIED_PARENT = '@@userManagement/UPDATE_ACL_USER_MODIFIED_PARENT',
	UPDATE_ACL_USER_MODIFIED_PHONE_NUMBER = '@@userManagement/UPDATE_ACL_USER_MODIFIED_PHONE_NUMBER',
	UPDATE_ACL_USER_MODIFIED_POSITION = '@@userManagement/UPDATE_ACL_USER_MODIFIED_POSITION',
	UPDATE_ACL_USER_MODIFIED_START_DATE = '@@userManagement/UPDATE_ACL_USER_MODIFIED_START_DATE',
	UPDATE_ACL_USER_MODIFIED_USER_ACTIVE = '@@userManagement/UPDATE_ACL_USER_MODIFIED_USER_ACTIVE',
	UPDATE_ACL_USER_MODIFIED_USERNAME = '@@userManagement/UPDATE_ACL_USER_MODIFIED_USERNAME',
	UPDATE_USER_RESOURCE_RIGHTS = '@@userManagement/UPDATE_USER_RESOURCE_RIGHTS',
	UPDATE_USER_RESOURCE_RIGHTS_FAILED = '@@userManagement/UPDATE_USER_RESOURCE_RIGHTS_FAILED',
	UPDATE_USER_RESOURCE_RIGHTS_SUCCEED = '@@userManagement/UPDATE_USER_RESOURCE_RIGHTS_SUCCEED',
	UPDATE_RIGHTS_BATCH = '@@userManagement/UPDATE_RIGHTS_BATCH',
	UPDATE_RIGHTS_BATCH_SUCCESS = '@@userManagement/UPDATE_RIGHTS_BATCH_SUCCESS',
	UPDATE_RIGHTS_BATCH_FAILURE = '@@userManagement/UPDATE_RIGHTS_BATCH_FAILURE',
	SET_RIGHTS_LOADING = '@@userManagement/SET_RIGHTS_LOADING',
}

export interface IUserManagementState {
	readonly allEmail: string[];
	readonly allUsernames: string[];
	readonly ACLRights: ACLRight[];
	readonly creationParam: IUserCreationParams;
	readonly creationParams: IUserCreationParams[];
	readonly impersonateToken: string;
	readonly isCreationSucceed: boolean;
	readonly isLoading: boolean;
	readonly isModificationSucceed: boolean;
	readonly lastSearchParams: IUserSearchParams;
	readonly lastSearchParamsSorting: IUserSearchParamsSorting;
	readonly parentsACLData: UserACL[];
	readonly rightsCount: number;
	readonly userCreationIsErrorMsg: string;
	readonly userRights: UserRights[];
	readonly usersACLData: UserACL[];
	readonly ACLUsersLoading: boolean;
	readonly ACLUserLoading: boolean;
	readonly usersCount: number;
	readonly userToModify: UserACL;
	readonly userModified: UserACL;
	readonly usersRetrived: string;
	readonly isRightsLoading: boolean;
}

export interface UserACL {
	readonly date_creation: string;
	readonly date_debut: string;
	readonly date_expire: string;
	readonly email: string;
	readonly firstname: string;
	readonly id: number;
	readonly isactive: boolean;
	readonly isgroup: boolean;
	readonly language: string;
	readonly localisation: string[];
	readonly name: string;
	readonly parent: Parent;
	readonly phone: string;
	readonly position: string;
	readonly username: string;
}

export interface Parent {
	readonly email: string;
	readonly id: number;
	readonly isactive: boolean;
	readonly isgroup: boolean;
	readonly name: string;
	readonly username: string;
}

export interface IUserSearchParams {
	readonly createdAfter?: string;
	readonly isGroup: boolean;
	readonly researchText: string;
	readonly showInactive: boolean;
	readonly usersParentID: number;
}

export interface IUserSearchParamsSorting {
	readonly sortingBy: 'ID' | 'FIRSTNAME' | 'NAME' | 'USERNAME';
	readonly sortingOrder: 'asc' | 'desc';
}

export interface UserRightsResources {
	readonly children: UserRights[];
	readonly id: number;
	readonly isparent: boolean;
	readonly name: string;
}

export interface ACLRight {
	readonly id: number;
	readonly name: string;
}

export interface UserRights {
	readonly id: number;
	readonly resource: UserRightsResources;
	readonly rights: ACLRight[];
	readonly origin: string;
}

export interface IUserCreationParams {
	readonly dateCreation: string;
	readonly dateDebut: string;
	readonly email: string;
	readonly firstname: string;
	readonly isActive: boolean;
	readonly isGroup: boolean;
	readonly language: string;
	readonly localisation: string[];
	readonly name: string;
	readonly parentID: number;
	readonly parentName: string;
	readonly password: string;
	readonly phone: string;
	readonly position: string;
	readonly username: string;
}
